// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__1h5Et","vertical":"_type_vertical__6fuRi"};